export default __webpack_public_path__ + "static/media/D100_CoC.09204266.pdf";